var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandArrow = function SvgExpandArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#44494D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.6 18.747-3.64-3.68-3.565 3.68a.788.788 0 0 1-1.156 0 .888.888 0 0 1 0-1.214l4.144-4.284a.801.801 0 0 1 .582-.249c.217 0 .426.09.578.253l4.217 4.28a.888.888 0 0 1-.127 1.326.799.799 0 0 1-1.033-.112Z",
    fill: "#44494D"
  })));
};
export default SvgExpandArrow;